<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">库存</span>
      <router-link to='/prep/wait/out' class="btn-pending ivu-btn ivu-btn-primary fr ml20">待出库区
        <span>{{pending_count}}</span>
      </router-link>
<!--      <router-link to='/Warehouse/SKU/Import' class="btn-pending ivu-btn ivu-btn-primary fr ml20">导入SKU信息</router-link> -->
    </div>
    <div class="clear-fix"></div>
    <div class="search-one mt20">
      <div class="search-item">
        UPC
        <Input class='ml10 mr20 w200' v-model="screen_data.sku" placeholder="请输入UPC" />
      </div>
      <div class="search-item">
        快递单号
        <Input class='ml10 mr20 w200' v-model="screen_data.waybill_code" placeholder="请输入快递单号" />
      </div>
      <div class="search-item">
        商品名称
        <Input class='ml10 mr20 w200' v-model="screen_data.product_name" placeholder="请输入商品名称" />
      </div>
      <div class="search-item">
        入库时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
      </div>
      <div class="search-item">
        <button v-if="active==1" class="ivu-btn ivu-btn-primary fr ml20" @click="exportData">导出</button>
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>
    </div>
    <div class="mt20 pb20">
      <Table stripe :loading="loading" border :columns="table_data.columns" :data="table_data.data">
        <template slot-scope="{ row, index }" slot="change">
          <span v-if="row.change_price > 0" style="color: #4acd40;">
            <Icon type="md-arrow-round-up" />{{row.change_rate_2}}%
          </span>
          <span v-if="row.change_price == 0">
            {{row.change_rate_2}}%
          </span>
          <span v-if="row.change_price <0" style="color: #ff0001;">
            <Icon type="md-arrow-round-down" />{{row.change_rate_2}}%
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="change_price">
          <span v-if="row.change_price > 0" style="color: #4acd40;">
            <Icon type="md-arrow-round-up" />{{row.change_price}}
          </span>
          <span v-if="row.change_price == 0">
            {{row.change_price}}
          </span>
          <span v-if="row.change_price <0" style="color: #ff0001;">
            <Icon type="md-arrow-round-down" />{{row.change_price}}
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="images">
          <span class="item-img mr10 fl" v-for="(v,i) in row.image_arr" :key="i" :src="v">
            <el-image style="width: 30px; height: 30px;margin-top: 10px;" :src="v" :preview-src-list="row.image_arr">
            </el-image>
          </span>
        </template>
      </Table>
    </div>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

    <Modal v-model="show_detail" :title="'FNSKU为'+edit_sku_info.sku+'的详情'" @on-ok="updateSKUInfo"
      @on-cancel="cancelSKUInfo" width="800">
      <ul class="new-account">
        <li class="list">
          <span class="label">
            ASIN
          </span>
          <span class="value">
            <Input v-model="edit_sku_info.product_sku" placeholder="请输入亚马逊ASIN" style="width: 200px" />
          </span>
        </li>
        <!-- <li class="list">
          <span class="label">
            退货订单编号
          </span>
          <span class="value">
            <Input v-model="edit_sku_info.return_order_no" placeholder="请输入退货订单编号" style="width: 200px" />
          </span>
        </li> -->
        <li class="list">
          <span class="label">
            商品名称
          </span>
          <span class="value">
            <Input v-model="edit_sku_info.product_name" placeholder="请输入姓名" style="width: 350px" />
          </span>
        </li>
        <!-- <li class="list">
          <span class="label">
            预计移货数量
          </span>
          <span class="value">
            <Input v-model="edit_sku_info.plan_return_count" placeholder="请输入预计移货数量" style="width: 100px" />
          </span>
        </li>
        <li class="list">
          <span class="label">
            业务员
          </span>
          <span class="value">
            <Input v-model="edit_sku_info.salesman" placeholder="请输入业务员" style="width: 150px" />
          </span>
        </li> -->
        <li class="list">
          <span class="label">
            备注
          </span>
          <span class="value">
            <Input v-model="edit_sku_info.remark" placeholder="请输入备注" style="width: 350px" />
          </span>
        </li>
      </ul>
      <div slot="footer" class="center">
        <span class="purple-btn" @click="updateSKUInfo">更新</span>
        <span class="b-btn" @click="cancelSKUInfo">取消</span>
      </div>
    </Modal>

  </main>
</template>

<script>
  import Paging from '@/components/common/paging'
  export default {
    components: {
      Paging
    },
    data() {
      return {
        pending_count: 0,
        detail_list: [],
        detailInfo: {},
        show_detail: false,
        edit_sku_info: [],
        active: 1,
        table_data: { //列表数据
          columns: [],
          data: []
        },
        category: [],
        website: [],
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          warehouse_id: '',
          client_code: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        detail_columns: [{
          title: 'SKU',
          key: 'sku',
          width: 200,
        }, {
          title: '商品名称',
          key: 'product_name',
          width: 400,
        }, {
          title: '入库数量',
          key: 'instock_count',
          width: 200,
        }]
      }
    },
    methods: {
      init() {
        this.table_data.columns = this.setColumns();
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList(this.active);
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList(this.active);
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList(this.active);
      },
      changeTab(type) {
        this.active = type;
        this.screen_data.pageNum = this.page_data.pageIndex = 1;
        this.getList(this.active);
      },
      /*
       * 获取列表  type : 1是按sku,2是按包裹号
       */
      getList(type) {
        this.$axios.get("/WarehouseStock/sku/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data) {
            res.data.forEach(v => {
              v.image_arr = []
              if (v.image_url) {
                v.image_arr = v.image_url.split(',')
              }
            })
            this.table_data.data = res.data;
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })

      },
      exportData() {
        this.$axios.get("/WarehouseStock/excel/export/sku/downloadcenter", {
          params: this.screen_data
        }).then(res => {
          if (res.success) {
            this.$Message.info('下载成功，请到下载中心中查看~');
          }
        })
      },
      getDetail(in_bill_no) {
        this.$axios.get("/WarehouseIn/bill/detail", {
          params: {
            in_bill_no: in_bill_no
          }
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            this.detail_list = res.data;
          }
          this.show_detail = true;
        })
      },
      setColumns(type) {
        let arr = [];
        arr = [{
          title: 'UPC',
          fixed: 'left',
          key: 'sku',
          tooltip: true,
          width: 180,
        }, {
          title: '客户编号',
          key: 'client_code',
          tooltip: true,
          width: 120,
        }, {
          title: '客户姓名',
          key: 'client_name',
          tooltip: true,
          width: 120,
        }, {
          title: 'ASIN',
          key: 'product_sku',
          minWidth: 200,
          tooltip: true
        }, {
          title: '商品名称',
          key: 'product_name',
          minWidth: 250,
          tooltip: true
        }, {
          title: '商品图片',
          key: 'image_url',
          minWidth: 250,
          slot: 'images'
        }, {
          title: '体积(m³)',
          key: 'dim',
          width: 250,
          render: (h, params) => {
            return h('span', params.row.dim + "m³ (" + params.row.length + "cm*" + params.row.width + "cm*" +
              params.row
              .height + "cm)")
          }
        }, {
          title: '在库上架数量',
          key: 'instock_onshelf_count',
          width: 120,
        }, {
          title: '待出库数量',
          key: 'pending_out_count',
          width: 100,
        }, {
          title: '累计总数量',
          key: 'total_count',
          width: 100,
        }, {
          title: '在库数量',
          key: 'instock_count',
          width: 100,
        }, {
          title: '备注',
          key: 'remark',
          width: 300,
        }, {
          title: '操作',
          width: 250,
          fixed: 'right',
          render: (h, params) => {
            let doms = [];
            doms.push(h('span', {
              style: {
                cursor: "pointer",
                color: "#0062da"
              },
              on: {
                click: () => {
                  this.detailInfo = params.row;
                  this.addPending(params.row)
                }
              }
            }, '添加到出库区 '));
            doms.push(h('span', {
              style: {
                cursor: "pointer",
                color: "#0062da"
              },
              on: {
                click: () => {
                  this.detailInfo = params.row;
                  this.editSKUInfo(params.row)
                }
              }
            }, ' 编辑UPC信息'));
            return h("div", doms);
          }
        }];
        return arr;
      },
      addPending(data) { //添加到出库区

        if (this.screen_data.client_code == undefined || this.screen_data.client_code == '') {
          this.$Message.error('请先在上方选择 子账户！');
          return;
        }
        this.$axios.post('/WarehouseStock/out/pending', this.$qs.stringify({
          client_code: data.client_code,
          sku: data.sku,
          out_count: data.out_count,
          warehouse_id: localStorage.getItem('warehouse_id')
        })).then((data) => {
          if (data.success) {
            this.$Message.success('添加成功');
            this.getList()
            this.getPendingCount()
          }
        })
      },
      getPendingCount() { //待出库区数量
        if (!this.screen_data.client_code) {
          return false;
        }
        this.$axios.get("/WarehouseStock/out/pending", {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            this.pending_count = res.data.length;
          }
        })
      },
      editSKUInfo(data) { //编辑SKU信息

        this.edit_sku_info = data;
        this.show_detail = true;

      },
      updateSKUInfo() {


        this.$axios.post("/WarehouseStock/sku/info", this.$qs.stringify(this.edit_sku_info)).then(res => {
          if (res.success) {
            this.$Message.success("更新成功");
            this.show_detail = false;
            this.getList(this.active);
          }
        });
      },
      cancelSKUInfo() {
        this.show_detail = false;
      }
    },
    created() {
      this.init();
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id') || '';
      this.screen_data.client_code = localStorage.getItem('client_code') || '';
      this.screen_data.biz_type = 3;
      if (this.screen_data.warehouse_id) {
        this.getList();
        this.getPendingCount()
      } else {
        this.$Message.info('请选择仓库')
      }

    }
  }
</script>

<style>
  .stock .w200 {
    width: 200px !important;
  }

  .tab-tr {
    float: right;
  }

  .tab-tr span {
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #4f6081;
    text-align: center;
    float: left;
    cursor: pointer;
  }

  .tab-tr span.active {
    background-color: #4f6081;
    color: #fff;
  }

  .btn-pending {
    line-height: 40px !important;
    margin-top: 40px;
    color: #FFFFFF !important;
    position: relative;
  }

  .btn-pending span {
    display: inline-block;
    background-color: red;
    color: #FFFFFF;
    position: absolute;
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    text-align: center;
    padding: 0;
    top: -10px;
    right: -10px;
    font-size: 13px;
  }
</style>
<style lang="scss">
  .new-account {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-right: 10px;
    }

    .list {
      height: 50px;
      line-height: 50px;
      // margin-bottom: 5px;
    }
  }

  .account {
    .account-box {
      margin: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/prep/stock/list.vue